import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import Gstr3BLayer from "../components/Gstr3BLayer";

const Gstr3BPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="GSTR-3B Report" />
        <Gstr3BLayer />
      </MasterLayout>
    </>
  );
};

export default Gstr3BPage;
